// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3nzxT","colCheckbox":"styles_colCheckbox__2EiEX"};